import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaSpinner } from 'react-icons/fa';

const ShowPakej = ({ setEditPakej }) => {
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/features/all/admin`);

        // Ensure features is an array
        const pakejData = Array.isArray(response.data) ? response.data : response.data.data || [];
        setFeatures(pakejData);
      } catch (error) {
        console.error("Error fetching features:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFeatures();
  }, []);  

  // Handle Delete item
  const handleDelete = async (id) => {
    const isConfirmed = window.confirm('Anda pasti nak padam pakej ini?');
    if (!isConfirmed) {
      return; // Exit if the user cancels
    }
  
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/features/${id}`);
      setFeatures(features.filter(feature => feature.id !== id));
      console.log('Item deleted successfully');
    } catch (error) {
      console.error('Error deleting item:', error);
    }
  };

  return (
    <div className="container mx-auto mt-4">
      {loading ? (
          <div className="flex justify-center items-center h-64">
            <FaSpinner className="text-red-400 text-4xl animate-spin" />
          </div>
        ) : (
          <ul className="space-y-4">
            {features.map((feature) => (
              <li key={feature.id} className="bg-white shadow-md rounded-lg p-4 flex flex-col space-y-4 md:flex-row items-center justify-between">
                <div className="flex items-center justify-start w-full">
                  <div>
                    <h2 className="text-xl font-semibold uppercase">{feature.pakej}</h2>
                  </div>
                </div>
                <div className="flex justify-between w-full md:w-1/3 space-x-2">
                  <button
                    onClick={() => setEditPakej(feature.pakej)} // Set editItem with feature ID
                    className="bg-blue-500 text-white px-4 py-2 w-full rounded-md hover:bg-blue-600"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(feature.id)}
                    className="bg-red-500 text-white px-4 py-2 w-full rounded-md hover:bg-button1Hover"
                  >
                    Delete
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
    </div>
  );
};

export default ShowPakej;
